/**
 * Do not edit directly
 * Generated on Thu, 01 Feb 2024 07:23:00 GMT
 */

module.exports = {
  "spinnerBorderWidthXs": "2px",
  "spinnerBorderWidthSm": "3px",
  "spinnerBorderWidthMd": "4px",
  "spinnerBorderWidthLg": "6px",
  "borderWidthSm": "1px",
  "borderRadiusSm": "4px",
  "borderRadiusMd": "8px",
  "borderRadiusLg": "12px",
  "borderRadiusXl": "16px",
  "borderRadius2xl": "20px",
  "borderRadius3xl": "24px",
  "breakpointMobile": "320px",
  "breakpointTablet": "768px",
  "breakpointDesktop": "992px",
  "breakpointLargedesktop": "1200px",
  "colorDanger100": "#ffebeb",
  "colorDanger200": "#ffc7cb",
  "colorDanger300": "#ffa8ad",
  "colorDanger400": "#ff8a90",
  "colorDanger500": "#ff6b73",
  "colorDanger600": "#ff2934",
  "colorDanger700": "#e5000c",
  "colorDanger800": "#a30009",
  "colorDanger900": "#660006",
  "colorGreyscale100": "#ffffff",
  "colorGreyscale200": "#f9fafc",
  "colorGreyscale300": "#f1f4f8",
  "colorGreyscale400": "#dee5ed",
  "colorGreyscale500": "#abbdd1",
  "colorGreyscale600": "#587698",
  "colorGreyscale700": "#37495c",
  "colorGreyscale800": "#25303c",
  "colorGreyscale900": "#0d0f12",
  "colorPrimary100": "#ebf5ff",
  "colorPrimary200": "#d6eaff",
  "colorPrimary300": "#7ab6ff",
  "colorPrimary400": "#3d91ff",
  "colorPrimary500": "#0d73ff",
  "colorPrimary600": "#0958d7",
  "colorPrimary700": "#0e43a4",
  "colorPrimary800": "#0e3681",
  "colorPrimary900": "#0d3073",
  "colorSecondary100": "#ffebeb",
  "colorSecondary200": "#ffc7cb",
  "colorSecondary300": "#ffa8ad",
  "colorSecondary400": "#ff8a90",
  "colorSecondary500": "#ff6b73",
  "colorSecondary600": "#ff2934",
  "colorSecondary700": "#e5000c",
  "colorSecondary800": "#a30009",
  "colorSecondary900": "#660006",
  "colorSuccess100": "#f2fffa",
  "colorSuccess200": "#ddf7ee",
  "colorSuccess300": "#91f6d2",
  "colorSuccess400": "#00e4a9",
  "colorSuccess500": "#00c996",
  "colorSuccess600": "#00ae82",
  "colorSuccess700": "#00946e",
  "colorSuccess800": "#00795a",
  "colorSuccess900": "#004332",
  "colorWarning100": "#fffaf2",
  "colorWarning200": "#fee6bd",
  "colorWarning300": "#fcd289",
  "colorWarning400": "#fbb43a",
  "colorWarning500": "#faa719",
  "colorWarning600": "#df8f05",
  "colorWarning700": "#c57e04",
  "colorWarning800": "#ab6d04",
  "colorWarning900": "#5c3b02",
  "fontFaceLabGrotesque400NormalWoff": "https://static.airhelp.com/fonts/LabGrotesque-Regular.woff",
  "fontFaceLabGrotesque400NormalWoff2": "https://static.airhelp.com/fonts/LabGrotesque-Regular.woff2",
  "fontFaceLabGrotesque500NormalWoff": "https://static.airhelp.com/fonts/LabGrotesque-Medium.woff",
  "fontFaceLabGrotesque500NormalWoff2": "https://static.airhelp.com/fonts/LabGrotesque-Medium.woff2",
  "fontFaceLabGrotesque700NormalWoff": "https://static.airhelp.com/fonts/LabGrotesque-Bold.woff",
  "fontFaceLabGrotesque700NormalWoff2": "https://static.airhelp.com/fonts/LabGrotesque-Bold.woff2",
  "fontFaceNotoSansSc400NormalWoff2": "https://static.airhelp.com/fonts/NotoSans-SC-Regular.woff2",
  "fontFaceNotoSansSc500NormalWoff2": "https://static.airhelp.com/fonts/NotoSans-SC-Medium.woff2",
  "fontFaceNotoSansSc700NormalWoff2": "https://static.airhelp.com/fonts/NotoSans-SC-Bold.woff2",
  "fontFaceNotoSansArabic400NormalWoff2": "https://static.airhelp.com/fonts/NotoSans-Arabic-Regular.woff2",
  "fontFaceNotoSansArabic500NormalWoff2": "https://static.airhelp.com/fonts/NotoSans-Arabic-Medium.woff2",
  "fontFaceNotoSansArabic700NormalWoff2": "https://static.airhelp.com/fonts/NotoSans-Arabic-Bold.woff2",
  "fontFamilyMain": "'Lab Grotesque', sans-serif",
  "fontFamilyZhCn": "'Noto Sans SC', sans-serif",
  "fontFamilyAr": "'Noto Sans Aabic', sans-serif",
  "fontSizeXs": "0.75rem",
  "fontSizeSm": "0.875rem",
  "fontSizeMd": "1rem",
  "fontSizeLg": "1.125rem",
  "fontSizeXl": "1.375rem",
  "fontSize2xl": "1.5rem",
  "fontSize3xl": "2rem",
  "fontSize4xl": "2.5rem",
  "fontSize5xl": "3rem",
  "fontWeightNormal": 400,
  "fontWeightMedium": 500,
  "fontWeightBold": 700,
  "heightButtonXs": "32px",
  "heightButtonSm": "40px",
  "heightButtonMd": "48px",
  "heightButtonLg": "56px",
  "heightButtonXl": "72px",
  "heightButtonIconSm": "16px",
  "heightButtonIconMd": "20px",
  "heightButtonIconLg": "24px",
  "heightButtonSpinnerXs": "16px",
  "heightButtonSpinnerSm": "20px",
  "heightButtonSpinnerMd": "24px",
  "heightButtonSpinnerLg": "28px",
  "heightButtonSpinnerXl": "32px",
  "heightSpinnerMd": "48px",
  "heightSpinnerLg": "64px",
  "lineHeightNone": 1,
  "lineHeightShort": 1.2,
  "lineHeightBase": 1.5,
  "shadowsNone": "none",
  "shadowsBase": "0px 1px 4px rgba(30, 41, 54, 0.2)",
  "shadowsMd": "0px 4px 12px rgba(30, 41, 54, 0.16)",
  "shadowsLg": "0px 8px 32px rgba(30, 41, 54, 0.12)",
  "shadowsAlt": "4px 8px 26px rgba(182, 190, 209, 0.25)",
  "spacingAuto": "auto",
  "spacing1x": "4px",
  "spacing2x": "8px",
  "spacing3x": "12px",
  "spacing4x": "16px",
  "spacing5x": "20px",
  "spacing6x": "24px",
  "spacing8x": "32px",
  "spacing10x": "40px",
  "spacing12x": "48px",
  "spacing16x": "64px",
  "spacing24x": "96px",
  "spacing32x": "128px"
};
